import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { THistoryDiffData } from '../../../../types/history';
import { checkResData } from '../../../../utils/common';

export type TProps = {
  id: number;
  apiRequest: (id: number) => Promise<any>; // 差分のapiを指定。apiからのレスポンスを定義できないのでany,
  createHistoryDiffList: (
    apiResponseHistoryDiff: any
  ) => Array<THistoryDiffData>; // apiのレスポンスから画面に表示する差分データを作成する
};

export const useHooks = (props: TProps) => {
  const { id, apiRequest, createHistoryDiffList } = props;
  const [historyDiffDataList, setHistoryDiffDataList] = useState<
    Array<THistoryDiffData>
  >([]);

  const [needApiRequest, setNeedApiRequest] = useState<boolean>(true);
  const { enqueueSnackbar } = useSnackbar();

  const onChange = async () => {
    if (needApiRequest) {
      apiRequest(id).then(resData => {
        checkResData(resData, enqueueSnackbar).then(data => {
          if (data) {
            setHistoryDiffDataList(createHistoryDiffList(data));
            setNeedApiRequest(false);
          }
        });
      });
    }
  };

  return { historyDiffDataList, onChange };
};
